import APIURLConstants from "../common/ApiURLConstants";
import APIHelper from "../common/ApiHelper";
import { authHeader } from "../helper";

export const UserManagementService = {
  getTeams,
  getUserRoles,
  addUpdateUser,
  getUserWithRoles,
  deleteUserRole,
};

async function getTeams(IncludeDummyTeam = true) {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_TEAMS}?IncludeDummyTeam=${IncludeDummyTeam}`,
    authHeader()
  );
  return response;
}

async function getUserRoles() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_USER_ROLES}`,
    authHeader()
  );
  return response;
}

async function addUpdateUser(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.ADD_UPDATE_USER}`,
    formObj,
    authHeader()
  );
  return response;
}

async function getUserWithRoles(userId = 0) {
  const url =
    typeof userId === "number" && userId > 0
      ? `${APIURLConstants.GET_ALL_USER_WITH_ROLES}/${userId}`
      : APIURLConstants.GET_ALL_USER_WITH_ROLES;

  const response = APIHelper.get(url, authHeader());

  return response;
}

async function deleteUserRole(userRoleId, processedBy) {
  const response = await APIHelper.post(
    `${APIURLConstants.DELETE_USER_ROLE}?UserRoleId=${userRoleId}&ProcessedBy=${processedBy}`,
    authHeader()
  );
  return response;
}
